import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';

import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/languages/zh_cn.js';
@Component({
  selector: 'nz-wysiwyg-net',
  preserveWhitespaces: false,
  templateUrl: './wysiwyg-net.component.html'
})

export class NzWysiwygNetComponent implements OnInit{

  constructor(public el:ElementRef) {
  }

  @Output('onHtmlChange') onHtmlChange: EventEmitter<any> = new EventEmitter;
  @Input('options') otherOptions: Object;
  @Input('HTML') editorContent: string;
  public options: Object = {
    placeholderText: "è¾å¥åå®¹...",
    language: 'zh_cn',
    events : {
      'froalaEditor.html.get' : (e, editor, html) => {
        this.onHtmlChange.emit(html);
      }
    }
  }

  ngOnInit(): void {
    this.options = {...this.options, ...this.otherOptions};
    this.removeLicense();
  }

  removeLicense(): void {
    let license: HTMLElement = this.el.nativeElement.querySelector("a[href='https://www.froala.com/wysiwyg-editor?k=u']");
    if (license) {
      license.style.display = "none;"
      license.parentElement.style.display = "none;"
      this.el.nativeElement.removeChild(license.parentElement);
    }
  }
}
